import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "./shared/ui/assets/app.scss";
import Router from "./shared/router/index";
import { AuthProvider } from "./pages/admin/login/auth-guard/AuthContext";
import { LanguageProvider } from "./shared/hooks/useLanguageContext";
import { ModalProvider, SourceInfoModal } from "./shared/ui/portal";
import "./shared/config/i18n"; // i18n 초기화

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5분
      gcTime: 10 * 60 * 1000, // 10분 (이전 cacheTime)
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <AuthProvider>
          <ModalProvider>
            <Router />
            <SourceInfoModal />
            <ReactQueryDevtools initialIsOpen={false} />
          </ModalProvider>
        </AuthProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
}

export default App;
